import { useCurrentUser } from './useAppDetails';
import { determineUserRoleInPlatform } from '../utils/user';
import { useCurrentOrganizationId } from './useCurrentOrganization';
import { useDispatch } from 'react-redux';
import { getCurrentUser } from '../actions/app';
import { useEffect } from 'react';
import { getCurrentOrganization } from '../actions/organizations';

export const useUserPlatformAccess = () => {
  const currentUser = useCurrentUser();
  const currentOrganizationId = useCurrentOrganizationId();

  const dispatch = useDispatch();
  useEffect(() => {
    if (!currentUser) {
      dispatch(getCurrentUser());
    }
  }, [currentUser, dispatch]);

  useEffect(() => {
    if (!currentOrganizationId) {
      dispatch(getCurrentOrganization());
    }
  }, [currentOrganizationId, dispatch]);

  return determineUserRoleInPlatform(currentUser, currentOrganizationId);
};
